/* RESPONSIBLE TEAM: team-proactive-support */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import { and } from '@ember/object/computed';
import { stats } from 'embercom/models/data/stats-system/stats-constants';
import ViewModeConfig from 'embercom/objects/content-editor/view-mode-configuration';
import TabsConfiguration from 'embercom/objects/content-editor/tabs-configuration';
import ActiveViewConfiguration from 'embercom/objects/content-editor/active-view-configuration';
import StandardContentTabConfiguration from 'embercom/objects/content-editor/tabs/standard-content-tab-configuration';
import StandardStatTabConfiguration from 'embercom/objects/content-editor/tabs/standard-stat-tab-configuration';
import StandardStatListConfiguration from 'embercom/objects/content-editor/stats/standard-stat-list-configuration';
import {
  StandardAudienceSummaryConfiguration,
  StandardGoalSummaryConfiguration,
  StandardScheduleSummaryConfiguration,
} from 'embercom/objects/content-editor/summaries/standard-summary-configurations';
import ContentSummaryConfiguration from 'embercom/objects/content-editor/summaries/content/post/summary-configuration';
import StandardViewModeHeaderConfiguration from 'embercom/objects/content-editor/headers/view-mode/standard-header-configuration';
import StandardSeriesViewModeHeaderConfiguration from 'embercom/objects/content-editor/headers/view-mode/standard-series-header-configuration';
import MoreDropdownConfiguration from 'embercom/objects/content-editor/headers/more-dropdown-configuration';
import ComponentConfiguration from 'embercom/objects/content-editor/component-configuration';

export default function generateViewModeConfig(options) {
  let container = options.container;
  let intl = container.lookup('service:intl');
  return ViewModeConfig.create({
    seriesHeaderComponentConfig: StandardSeriesViewModeHeaderConfiguration.create({
      moreDropdownConfig: MoreDropdownConfiguration.create({
        hideDuplicateOption: true,
        hideCsvExportOption: false,
        hideTagOption: true,
        hideDeleteOption: true,
        hideVersionsOption: true,
        container,
      }),
      container,
    }),
    headerComponentConfigs: [
      StandardViewModeHeaderConfiguration.create({
        container,
        previewConfig: ComponentConfiguration.create({
          container,
          component: 'content-editor/headers/post/preview-button',
        }),
      }),
    ],
    tabsConfiguration: TabsConfiguration.create({
      container,
      tabComponentConfigs: [
        StandardContentTabConfiguration.create({
          label: 'Post',
          icon: 'inapp-post',
          view: 'content',
        }),
        StandardStatTabConfiguration.create({
          label: intl.t('outbound.stats-system.tabs.sent'),
          view: 'receipts',
          container,
        }),
        StandardStatTabConfiguration.create({
          label: intl.t('outbound.stats-system.tabs.opened'),
          view: 'opens',
          container,
        }),
        StandardStatTabConfiguration.create({
          label: intl.t('outbound.stats-system.tabs.clicked'),
          view: 'clicks',
          container,
        }),
        StandardStatTabConfiguration.extend({
          isVisible: and('contentEditorService.activeObject.isTextReply', 'isNotDraft'),
        }).create({
          label: intl.t('outbound.stats-system.tabs.replied'),
          view: 'replies',
          container,
        }),
        StandardStatTabConfiguration.extend({
          isVisible: and('contentEditorService.activeObject.isReactionsReply', 'isNotDraft'),
        }).create({
          label: 'Reacted',
          view: 'reactions',
          tabComponent: 'content-editor/tabs/reactions/stat-tab',
          container,
        }),
        StandardStatTabConfiguration.extend({
          isVisible: and('contentEditorService.ruleset.hasGoal', 'isNotDraft'),
        }).create({
          label: intl.t('outbound.stats-system.tabs.goal'),
          view: 'goals',
          container,
        }),
      ],
    }),
    activeViewConfiguration: ActiveViewConfiguration.create({
      content: [
        ContentSummaryConfiguration.create({ container }),
        StandardAudienceSummaryConfiguration.create({ container }),
        StandardScheduleSummaryConfiguration.create({
          title: 'Frequency and scheduling',
          container,
        }),
        StandardGoalSummaryConfiguration.create({ container }),
      ],
      receipts: [
        StandardStatListConfiguration.create({
          stat: 'receipt',
          hideCreatedVia: true,
          noun: 'send',
          verb: 'received',
          emptyStateTitle: "No one's been sent your post yet",
          emptyStateDescription: ' ', // We need a non-empty value as override in order to hide description
          container,
        }),
      ],
      opens: [
        StandardStatListConfiguration.create({ stat: 'open', hideCreatedVia: true, container }),
      ],
      clicks: [StandardStatListConfiguration.create({ stat: 'click', container })],
      replies: [StandardStatListConfiguration.create({ stat: 'reply', container })],
      reactions: [StandardStatListConfiguration.create({ stat: 'reaction', container })],
      goals: [
        StandardStatListConfiguration.create({
          filters: [
            { text: 'Hit the goal after opening', value: stats.open },
            { text: 'Hit the goal after clicking', value: stats.click },
            { text: 'Hit the goal after replying', value: stats.reply },
            { text: 'Hit the goal after reacting', value: stats.reaction },
          ],
          stat: 'goalSuccess',
          container,
        }),
      ],
    }),
    footerComponentConfigs: [],
  });
}
